<html>

<head>
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <style lang="javascript">
    body > div.loading-spinner-container {
      position: absolute;
      z-index: 666;
      top: 0; right: 0; bottom: 0; left: 0;
      display: grid;
      align-items: center;
      justify-content: center;
    }
    * {box-shadow: none; box-sizing: border-box;}
    html {font-family: 'Lato', sans-serif; font-size: 9pt;}
		header, main, footer, table {width: 100%; position: relative; z-index: 3;}

    body.example header {position: relative;}
    body.example header *,
    body.example footer * {position: relative; z-index: 2;}
    body.example footer {position: relative;}

    body > div.page > header {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      gap: 8pt;
    }

		table {border-collapse: collapse;}
		table tr td, table tr th {padding: 0; min-width: 10%; text-align: left;}
    html, body, #pdf {width: 793px; height: 1122px; padding: 0; margin: 0; position: relative;}
    table tr td, table tr th {border: none; font-size: 9pt;}
    body > div.page#pdf {padding: 38px 38px 38px 76px;}
    body > div.page > img.logo {position: absolute; top: 38px; right: 38px; max-width: 56px; height: auto; z-index: 3;}
    body > div.page > img.stationary {position: absolute; top: 0; right: 0; bottom: 0; left: 0; width: 793px; height: 1122px; z-index: 2;}

    body > div.page > header > h1 {margin: 19px 0 19px 0; font-size: 24pt;}
    body > div.page > header > table {table-layout: fixed;}
    body > div.page > header > table.addresses {margin-bottom: 9px;}
    body > div.page > header > table.addresses tr:first-child td {padding-bottom: 9px;}

    body > div.page > main > h2 {margin: 19px 0; font-size: 16pt;}
    body > div.page > main table {table-layout: fixed;}
    body > div.page > main table tr th {vertical-align: bottom;}
    body > div.page > main table tr td {padding: 4px 0;}
    body > div.page > main table tr :not(:last-child) {padding-right: 9px;}
    body > div.page > main table tr > :last-child {padding-right: 0; text-align: right;}
    body > div.page > main table tr .meter,
    body > div.page > main table tr .currency,
    body > div.page > main table tr .delivery {text-align: right;}
    body > div.page > main table tr .currency {width: 64px;}
    body > div.page > main table tr .delivery {width: 92px;}
    body > div.page > main table tr .currency:last-child {width: 48px;}
    body > div.page > main table tr.result td.caption {padding-left: 0; margin-left: 0; text-align: right;}
    body > div.page > main table tr.result td.caption strong {padding: 0;}
    body > div.page > main table tr.sum td.caption + td,
    body > div.page > main table tr.sum td.caption + td + td {border-top: 1px solid #aaa; text-align: right;}
    body > div.page > main table tr.tax td.caption + td,
    body > div.page > main table tr.tax td.caption + td + td {text-align: right;}
    body > div.page > main table tr.amount td.caption + td,
    body > div.page > main table tr.amount td.caption + td + td {border-top: 4px double #aaa; text-align: right;}

    body > div.page > footer {width: 679px; position: absolute; bottom: 38px;}
    body > div.page > footer table {width: 100%;}
    body > div.page > footer table tr td {font-size: 7pt; padding: 0; vertical-align: bottom;}

    span.pageNumber {font-size: 8pt; padding: 4px 8px; background-color: #eee; border-radius: 1pt; float: right; text-align: right;}
  </style>
</head>

<body
  style="overflow: hidden; background-size: contain; background-position: top center; background-repeat: no-repeat;"
  [class]="example ? 'example' : ''">
  <div *ngIf="loading" class="loading-spinner-container">
    <div class="spinner-border text-primary loading-spinner-md" role="status">
      <span class="visually-hidden-focusable" i18n="@@GeneratingInvoicePdf">Erzeuge PDF</span>
    </div>
  </div>

  <div class="page" #pdf id="pdf">
    <img *ngIf="exampleSettings ? exampleSettings.isUsingStationery : invoiceSettings?.isUsingStationery"
      class="stationary"
      [src]="stationaryPreview ? stationaryPreview : stationary"
      [alt]="invoice?.recipientCompany || invoice?.recipientFullName">

    <header [style]="'height: ' + (exampleSettings ? exampleSettings.letterheadHeight : invoiceSettings?.letterheadHeight) + 'mm'">
      <h1>Rechnung</h1>
      <table>
        <tr><td width="20%"><strong>Rechnungsnummer:</strong></td><td>{{ invoice?.invoiceNumber }}</td></tr>
        <tr><td width="20%">Ausstellungsdatum:</td><td>{{ invoice?.createdAt | date: 'mediumDate':'de-DE' }}</td></tr>
        <tr><td width="20%">Fällig am:</td><td>{{ invoice?.dueAt | date: 'mediumDate':'de-DE' }}</td></tr>
      </table>
      <table class="addresses">
        <tr>
          <td><small>
            {{ invoice?.ownerCompany || invoice?.ownerFirstName + ' ' + invoice?.ownerLastName }}
            <span *ngIf="invoice?.ownerStreet && invoice?.ownerHouseNumber">&ensp;&bullet;&ensp;{{ invoice?.ownerStreet }} {{ invoice?.ownerHouseNumber }}</span>
            <span *ngIf="invoice?.ownerPostcode && invoice?.ownerCity">&ensp;&bullet;&ensp;{{ invoice?.ownerPostcode }} {{ invoice?.ownerCity }}</span>
          </small></td>
        </tr>
        <tr><td><strong>{{ invoice?.recipientCompany || invoice?.recipientFullName }}</strong></td></tr>
        <tr><td>{{ invoice?.recipientStreet }} {{ invoice?.recipientHouseNumber }}</td></tr>
        <tr><td>{{ invoice?.recipientPostcode }} {{ invoice?.recipientCity }}</td></tr>
        <tr><td>{{ invoice?.recipientEmail }}</td></tr>
      </table>
    </header>

    <main *ngIf="invoice.invoiceItems">
			<!-- <h2>
        {{ invoice?.invoiceAmount | currency: 'EUR' }} fällig am {{ invoice?.dueDate | date: 'mediumDate':'de-DE' }}
        <span class="pageNumber">Seite {{ currentPage }} von {{ pageCount }}</span>
      </h2> -->
      <p>
        <!-- <span i18n="@@InvoicePDFSalutation">{{ getSalutation() }}</span> {{ profile?.firstName + ' ' + profile?.lastName }},<br /> -->
        Gemäß Ihrem Auftrag stellen wir Ihnen folgende Leistungen in Rechnung.
      </p>
      <table class="table" *ngIf="transactionsOfPage">
        <tr>
          <th>Ladestation</th>
          <th class="meter" i18n="@@InvoiceStartMeterReading">Zählerstand</th>
					<th class="timestamp" i18n="@@InvoiceStartTime">Beginn</th>
          <th class="meter" i18n="@@InvoiceEndMeterReading">Zählerstand</th>
          <th class="timestamp" i18n="@@InvoiceEndTime">Ende</th>
          <th class="currency" i18n="@@InvoicePricePerKwh">€&thinsp;/&thinsp;kWh</th>
          <th class="delivery" i18n="@@invoiceMeterAmount">kWh geliefert</th>
          <th class="currency" i18n="@@InvoicePriceAmount">Betrag</th>
        </tr>
        <tr *ngFor="let transaction of transactionsOfPage.get(currentPage)">
          <td>{{ transaction.chargingStationName }}</td>
          <td class="meter">{{ transaction.meterStart | kwh }}</td>
					<td class="timestamp">{{ transaction.startTimestamp | dateDE: 'short':'+0000' }}</td>
          <td class="meter">{{ transaction.meterStop | kwh }}</td>
					<td class="timestamp">{{ transaction.stopTimestamp | dateDE: 'short':'+0000' }}</td>
          <td class="currency">€ {{ (transaction.pricing?.price ? transaction.pricing?.price : 0) | number: '1.2-2':'de-DE' }}</td>
          <td class="delivery">{{ transaction.meterAmount | kwh }}</td>
          <td class="currency">€ {{ transaction.price | number: '1.2-2':'de-DE' }}</td>
        </tr>
				<tr class="result sum" *ngIf="currentPage == pageCount">
					<td colspan="6" class="caption" i18n="@@InvoiceSubtotal"><strong>Zwischensumme:</strong></td>
					<td style="text-align: right">{{ invoice.invoiceMeterAmount | kwh }}</td>
					<td>€ {{ invoice.invoiceAmount | number: '1.2-2':'de-DE' }}</td>
				</tr>
				<tr class="result tax" *ngIf="currentPage == pageCount">
					<td colspan="6" class="caption" i18n="@@InvoiceNetto"><strong>Netto:</strong></td>
					<td></td>
					<td>€ {{ invoice.invoiceAmount - (invoice.invoiceAmount / 1.19 * 0.19) | number: '1.2-2':'de-DE' }}</td>
				</tr>
				<tr class="result tax" *ngIf="currentPage == pageCount">
					<td colspan="6" class="caption" i18n="@@InvoiceIncludeTax"><strong>inkl. 19 % MwSt:</strong></td>
					<td></td>
					<td>€ {{ invoice.invoiceAmount / 1.19 * 0.19 | number: '1.2-2':'de-DE' }}</td>
				</tr>
				<tr class="result amount" *ngIf="currentPage == pageCount">
					<td colspan="6" class="caption" i18n="@@InvoiceAmount"><strong>Rechnungsbetrag:</strong></td>
					<td></td>
					<td>€ {{ invoice.invoiceAmount | number: '1.2-2':'de-DE' }}</td>
				</tr>
      </table>
      <p style="padding-top: 19px;">
        Zahlbar bis einschließlich {{ invoice?.dueDate | date: 'longDate':'de-DE' }} ohne Abzug.
        <span class="pageNumber">Seite {{ currentPage }} von {{ pageCount }}</span>
      </p>
    </main>

    <footer [style]="'height: ' + (exampleSettings ? exampleSettings.footnoteHeight : invoiceSettings?.footnoteHeight) + 'mm'">
      <table *ngIf="exampleSettings != null ? exampleSettings.isUsingFootnote : invoiceSettings?.isUsingFootnote">
        <tr>
					<td i18n="@@InvoiceCompanyInfo">
						<strong>{{ invoice?.ownerCompany }}</strong><br />
						{{ invoice?.ownerStreet }}&nbsp;{{ invoice?.ownerHouseNumber }} in&nbsp;{{ invoice?.ownerPostcode }}&nbsp;{{ invoice?.ownerCity }}<br />
						<span *ngIf="exampleSettings?.ceo || invoice?.ownerCeo">Geschäftsführung:<br /></span>
						{{ exampleSettings ? exampleSettings?.ceo : invoice?.ownerCeo }}
					</td>
					<td>
						{{ invoice?.ownerPhone }}<br />
						{{ invoice?.ownerEmail }}<br />
					</td>
					<td i18n="@@InvoiceTaxInfo">
						<span *ngIf="exampleSettings?.vatId || invoice?.ownerVatId">Steuernummer/Umsatzsteuer-ID:<br /></span>
						{{ exampleSettings ? exampleSettings.vatId : invoice?.ownerVatId }}<br />
						<span *ngIf="exampleSettings?.commercialRegisterId || invoice?.ownerCommercialRegisterId">Handelsregister&nbsp;{{ exampleSettings ? exampleSettings.commercialRegister : invoice?.ownerCommercialRegister }}<br /></span>
						{{ exampleSettings ? exampleSettings.commercialRegisterId : invoice?.ownerCommercialRegisterId }}
					</td>
					<td i18n="@@InvoiceBankInfo">
						<span *ngIf="exampleSettings?.bank || invoice?.ownerBank">{{ exampleSettings ? exampleSettings.bank : invoice?.ownerBank }}<br /></span>
						<span *ngIf="exampleSettings?.iban || invoice?.ownerIban">IBAN {{ exampleSettings ? exampleSettings.iban : invoice?.ownerIban }}<br /></span>
						<span *ngIf="exampleSettings?.bic || invoice?.ownerBic">BIC {{ exampleSettings ? exampleSettings.bic : invoice?.ownerBic }}<br /></span>
					</td>
        </tr>
      </table>
    </footer>
  </div>
</body>

</html>
